import { useNavigate } from "react-router-dom";
import { Eye, Undo2 } from "lucide-react";
import { toast } from "sonner";
import { saveToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ADMIN_TOKEN_BACKUP } from "@/components/AdminImpersonateButton";

export const ImpersonationBanner = () => {
  const { user, checkAuth } = useAuth();
  const navigate = useNavigate();
  if (!user?.impersonated_by) return null;

  const back = async () => {
    const adminToken = localStorage.getItem(ADMIN_TOKEN_BACKUP);
    localStorage.removeItem(ADMIN_TOKEN_BACKUP);
    if (adminToken) saveToken(adminToken);
    await checkAuth();
    toast.success("Sei tornato al Pannello Admin");
    navigate(adminToken ? "/admin" : "/login", { replace: true });
  };

  return (
    <div className="sticky top-0 z-40 bg-amber-400 text-gray-900 text-sm font-medium px-4 py-2 flex flex-wrap items-center justify-center gap-3" data-testid="impersonation-banner">
      <Eye className="h-4 w-4" />
      <span>Stai vedendo la dashboard di <strong>{user.name || user.email}</strong> ({user.email}) come amministratore.</span>
      <button onClick={back} className="inline-flex items-center gap-1.5 rounded-full bg-gray-900 text-white px-3 py-1 text-xs font-semibold hover:bg-gray-800" data-testid="impersonation-exit">
        <Undo2 className="h-3.5 w-3.5" /> Torna al Pannello Admin
      </button>
    </div>
  );
};
